module.exports = __webpack_public_path__ + "static/img/banner_pohone.4f74d95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner_pohone.png
// module id = 77
// module chunks = 1 4